import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import clientValidation from './clientValidation';
import * as clientActions from 'redux/modules/clients';
var Datetime = require('react-datetime');
import { Panel, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';

import i18next from 'i18next';

@translate(['common'])
@connect(
  state => ({
    saveError: state.clients.saveError,
    modules: state.modules.data,
  }),
  dispatch => bindActionCreators(clientActions, dispatch)
)
@reduxForm({
  form: 'client',
  fields: ['id', 'login', 'email', 'first_name', 'last_name', 'phone', 'modules',
    'abonnements[].expiry_date', 'abonnements[].rappel1', 'etat',
    'abonnements[].rappel2', 'abonnements[].name', 'abonnements[].com_id', 'abonnements[].cli_id', 'touched'],
  validate: clientValidation,
})
export default class ClientForm extends Component {
  

  render() {
    const {
      editStop,
      fields, formKey, handleSubmit, invalid,
      pristine, save, submitting,
      saveError: { [formKey]: saveError },
      values, modules, commercials, resetForm,
      initialValues, initialize
    } = this.props;
    
    const {t} = this.props


    const styles = require('containers/Client/Clients.scss');

    return (
      <tr className={submitting ? styles.saving : ''}>
        <td className={styles.sprocketsCol}>
          <div>
            <label for="username">{t('main.username')}</label><br />
            <input disabled={true} id="username" name="username" type="text" className="form-control" {...fields['login']} />
            {fields['login'].error && fields['login'].touched && <div className="text-danger">{fields['login'].error}</div>}
          </div>
          <br />
          <div>
            <label for="first_name">{t('main.firstname')}</label>
            <input id="first_name" name="first_name" type="text" className="form-control" {...fields['first_name']} />
            {fields['first_name'].error && fields['first_name'].touched && <div className="text-danger">{fields['first_name'].error}</div>}
          </div>
          <br />
          <div>
            <label for="last_name">{t('main.lastname')}</label>
            <input id="last_name" name="last_name" type="text" className="form-control" {...fields['last_name']} />
            {fields['last_name'].error && fields['last_name'].touched && <div className="text-danger">{fields['last_name'].error}</div>}
          </div>


          <br />

          <div style={{width:"216px"}}>
            <label for="etat">{t('main.state')}</label><br />
            <input type="radio" {...fields['etat']} value="1" checked={fields['etat'].value == '1'} /> {t('main.active')}&nbsp;
            <input type="radio" {...fields['etat']} value="0" checked={fields['etat'].value == '0'} /> {t('main.inactive')}&nbsp;
            <input type="radio" {...fields['etat']} value="2" checked={fields['etat'].value == '2'} /> {t('main.suspended')}
          </div>


        </td>

        <td className={styles.ownerCol}>
          <div style={{width:"140px"}}>
            <label for="email">{t('main.email')}</label><br />
            <input name="email" type="text" className="form-control" {...fields['email']} />
            {fields['email'].error && fields['email'].touched && <div className="text-danger">{fields['email'].error}</div>}
          </div>
        </td>

        
        <td className={styles.ownerCol}>
          <div>
            <label for="phone">{t('main.phone')}</label><br />
            <input id="phone" name="phone" type="text" className="form-control" {...fields['phone']} />
            {fields['phone'].error && fields['phone'].touched && <div className="text-danger">{fields['phone'].error}</div>}
          </div>
        </td>


        <td className={styles.ownerCol}>
          <label for="modules">{t('main.modules')}</label><br />
          <select className="form-control" id="modules" name="modules" style={{ width: '150px' }} multiple {...fields['modules']}>
            {modules.map(module => <option key={module.id} value={module.id}>{module.name}</option>)}
          </select>
        </td>


        <td className={styles.ownerCol}>
          {/*<select className="form-control" name="modules" style={{width:'150px'}} multiple {...fields['commercials']}>
            {commercials.map(com => <option key={com.id} value={com.id}>{com.login}</option>)}
          </select>*/}
          {fields['abonnements'].map((ab, index) => <Panel style={{ width: '200px' }} defaultCollapsed={false} collapsible
            header={<div>{t('main.commercial')} {ab.name.value} <span onClick={() => {
              fields['abonnements'].removeField(index);
              fields['touched'].onChange(true);
            }}><i className="fa fa-times-circle" />
            </span></div>} key={index}>

            <div>
              <label for="expiry_date">{t('main.commercial')}</label>
              <select className="form-control" style={{ width: '150px' }}  {...ab['com_id']}>
                {commercials.map(com => <option key={com.id} value={com.id}>{com.login}</option>)}
              </select>
            </div>

            <br />

            <div>
              <label for="expiry_date">{t('main.contract_date')}</label>
              <Datetime id="expiry_date" style={{ 'width': '120px' }} {...ab['expiry_date']} locale={i18next.language}
                onChange={(date) => ab.expiry_date.onChange(date)} ref="expiry_date" />
            </div>

            <br />
            <div>
              <label for="rappel1">{t('main.rappel1')}</label>
              <Datetime id="rappel1" style={{ 'width': '120px' }} {...ab['rappel1']} locale={i18next.language}
                onChange={(date) => ab.rappel1.onChange(date)} ref="rappel1" />
            </div>


            <br />
            <div>
              <label for="rappel2">{t('main.rappel2')}</label>
              <Datetime id="rappel2" style={{ 'width': '120px' }} {...ab['rappel2']} locale={i18next.language}
                onChange={(date) => ab.rappel2.onChange(date)} ref="rappel2" />
            </div>

          </Panel>)}


          <Button bsStyle="primary" onClick={() => {
            fields['abonnements'].addField({ cli_id: this.props.initialValues2.id });
            fields['touched'].onChange(true);
          }}><i className="fa fa-plus-circle"></i>
          </Button>



        </td>


        <td className={styles.buttonCol}>
          <button className="btn btn-default"
            onClick={() => editStop(formKey)}
            disabled={submitting}>
            <i className="fa fa-ban" />
          </button>&nbsp;
          <button className="btn btn-success"
            onClick={handleSubmit(() =>
              save(values)
                .then(result => {
                  alert('ok')
                  if (result && typeof result.error === 'object') {
                    return Promise.reject(result.error);
                  }
                })
            )}
            disabled={pristine || invalid || submitting}>
            <i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-floppy-o')} />
          </button>
          &nbsp;
          <Button type="button" bsStyle="danger" disabled={submitting} onClick={() => this.props.initializeForm(this.props.initialValues2)}>
            {t('main.reset')}
          </Button>

          {saveError && <div className="text-danger">{saveError}</div>}
        </td>
      </tr>
    );
  }
}
